<div class="confetti-stage" aria-hidden="true">

  <!-- Gold triangles standard -->
  <div class="piece tri-gold p1"></div>
  <div class="piece tri-gold p2"></div>
  <div class="piece tri-gold p3"></div>
  <div class="piece tri-gold p4"></div>
  <div class="piece tri-gold p5"></div>
  <div class="piece tri-gold p6"></div>
  <div class="piece tri-gold p7"></div>
  <div class="piece tri-gold p8"></div>
  <div class="piece tri-gold p9"></div>
  <div class="piece tri-gold p10"></div>

  <!-- Blue medium triangles -->
  <div class="piece tri-blue-md p11"></div>
  <div class="piece tri-blue-md p12"></div>
  <div class="piece tri-blue-md p13"></div>
  <div class="piece tri-blue-md p14"></div>
  <div class="piece tri-blue-md p15"></div>
  <div class="piece tri-blue-md p16"></div>
  <div class="piece tri-blue-md p17"></div>
  <div class="piece tri-blue-md p18"></div>
  <div class="piece tri-blue-md p19"></div>
  <div class="piece tri-blue-md p20"></div>

  <!-- Blue small triangles -->
  <div class="piece tri-blue-sm p21"></div>
  <div class="piece tri-blue-sm p22"></div>
  <div class="piece tri-blue-sm p23"></div>
  <div class="piece tri-blue-sm p24"></div>
  <div class="piece tri-blue-sm p25"></div>
  <div class="piece tri-blue-sm p26"></div>
  <div class="piece tri-blue-sm p27"></div>
  <div class="piece tri-blue-sm p28"></div>

  <!-- Blue specks -->
  <div class="piece tri-blue-xs p29"></div>
  <div class="piece tri-blue-xs p30"></div>
  <div class="piece tri-blue-xs p31"></div>
  <div class="piece tri-blue-xs p32"></div>
  <div class="piece tri-blue-xs p33"></div>
  <div class="piece tri-blue-xs p34"></div>
  <div class="piece tri-blue-xs p35"></div>
  <div class="piece tri-blue-xs p36"></div>
  <div class="piece tri-blue-xs p37"></div>
  <div class="piece tri-blue-xs p38"></div>

  <!-- Pink-purple rectangles large -->
  <div class="piece rect-pink-lg p39"></div>
  <div class="piece rect-pink-lg p40"></div>
  <div class="piece rect-pink-lg p41"></div>
  <div class="piece rect-pink-lg p42"></div>
  <div class="piece rect-pink-lg p43"></div>
  <div class="piece rect-pink-lg p44"></div>

  <!-- Pink-purple rectangles small -->
  <div class="piece rect-pink-sm p45"></div>
  <div class="piece rect-pink-sm p46"></div>
  <div class="piece rect-pink-sm p47"></div>
  <div class="piece rect-pink-sm p48"></div>

  <!-- Red triangles -->
  <div class="piece tri-red p49"></div>
  <div class="piece tri-red p50"></div>
  <div class="piece tri-red p51"></div>
  <div class="piece tri-red p52"></div>
  <div class="piece tri-red p53"></div>
  <div class="piece tri-red p54"></div>
  <div class="piece tri-red p55"></div>
  <div class="piece tri-red p56"></div>

  <!-- Teal accent rectangles -->
  <div class="piece rect-teal p57"></div>
  <div class="piece rect-teal p58"></div>
  <div class="piece rect-teal p59"></div>
  <div class="piece rect-teal p60"></div>
  <div class="piece rect-teal p61"></div>
  <div class="piece rect-teal p62"></div>

  <!-- BIG gold triangles — burst splash from center -->
  <div class="piece tri-gold-lg p63"></div>
  <div class="piece tri-gold-lg p64"></div>
  <div class="piece tri-gold-lg p65"></div>
  <div class="piece tri-gold-lg p66"></div>
  <div class="piece tri-gold-lg p67"></div>
  <div class="piece tri-gold-lg p68"></div>

  <!-- BIG blue triangles — burst splash -->
  <div class="piece tri-blue-lg p69"></div>
  <div class="piece tri-blue-lg p70"></div>
  <div class="piece tri-blue-lg p71"></div>
  <div class="piece tri-blue-lg p72"></div>
  <div class="piece tri-blue-lg p73"></div>
  <div class="piece tri-blue-lg p74"></div>

  <!-- BIG pink-purple rectangles — burst splash -->
  <div class="piece rect-pink-xl p75"></div>
  <div class="piece rect-pink-xl p76"></div>
  <div class="piece rect-pink-xl p77"></div>
  <div class="piece rect-pink-xl p78"></div>

  <!-- BIG teal rectangles — burst splash -->
  <div class="piece rect-teal-lg p79"></div>
  <div class="piece rect-teal-lg p80"></div>
  <div class="piece rect-teal-lg p81"></div>
  <div class="piece rect-teal-lg p82"></div>

  <!-- Edge + gap fill -->
  <div class="piece tri-gold p83"></div>
  <div class="piece tri-blue-md p84"></div>
  <div class="piece rect-pink-lg p85"></div>
  <div class="piece tri-red p86"></div>
  <div class="piece tri-gold-lg p87"></div>
  <div class="piece rect-teal-lg p88"></div>

  <!-- Green dots -->
  <div class="piece dot-green p89"></div>
  <div class="piece dot-green p90"></div>
  <div class="piece dot-green p91"></div>
  <div class="piece dot-green p92"></div>
  <div class="piece dot-green p93"></div>
  <div class="piece dot-green p94"></div>

  <!-- Purple dots — some burst splash -->
  <div class="piece dot-purple p95"></div>
  <div class="piece dot-purple p96"></div>
  <div class="piece dot-purple p97"></div>
  <div class="piece dot-purple p98"></div>
  <div class="piece dot-purple p99"></div>
  <div class="piece dot-purple p100"></div>

  <!-- Yellow dots -->
  <div class="piece dot-yellow p101"></div>
  <div class="piece dot-yellow p102"></div>
  <div class="piece dot-yellow p103"></div>
  <div class="piece dot-yellow p104"></div>
  <div class="piece dot-yellow p105"></div>

  <!-- Orange squares — some burst -->
  <div class="piece sq-orange p106"></div>
  <div class="piece sq-orange p107"></div>
  <div class="piece sq-orange p108"></div>
  <div class="piece sq-orange p109"></div>
  <div class="piece sq-orange p110"></div>

  <!-- Coral triangles -->
  <div class="piece tri-coral p111"></div>
  <div class="piece tri-coral p112"></div>
  <div class="piece tri-coral p113"></div>
  <div class="piece tri-coral p114"></div>
  <div class="piece tri-coral p115"></div>

  <!-- Lime green rectangles -->
  <div class="piece rect-lime p116"></div>
  <div class="piece rect-lime p117"></div>
  <div class="piece rect-lime p118"></div>
  <div class="piece rect-lime p119"></div>
  <div class="piece rect-lime p120"></div>

  <!-- Fast sprinters — zip past quickly -->
  <div class="piece tri-gold p121"></div>
  <div class="piece dot-yellow p122"></div>
  <div class="piece tri-coral p123"></div>
  <div class="piece dot-green p124"></div>
  <div class="piece tri-blue-md p125"></div>
  <div class="piece sq-orange p126"></div>
  <div class="piece tri-red p127"></div>
  <div class="piece dot-purple p128"></div>
  <div class="piece tri-gold-lg p129"></div>
  <div class="piece rect-lime p130"></div>

  <!-- Slow drifters — float lazily -->
  <div class="piece rect-pink-lg p131"></div>
  <div class="piece tri-blue-lg p132"></div>
  <div class="piece dot-green p133"></div>
  <div class="piece rect-teal-lg p134"></div>
  <div class="piece tri-gold p135"></div>
  <div class="piece rect-pink-xl p136"></div>
  <div class="piece tri-blue-xs p137"></div>
  <div class="piece dot-yellow p138"></div>
  <div class="piece tri-coral p139"></div>
  <div class="piece sq-orange p140"></div>

  <!-- Medium-fast — varied positions -->
  <div class="piece dot-purple p141"></div>
  <div class="piece tri-gold p142"></div>
  <div class="piece tri-blue-lg p143"></div>
  <div class="piece rect-teal p144"></div>
  <div class="piece dot-green p145"></div>
  <div class="piece tri-red p146"></div>
  <div class="piece rect-pink-sm p147"></div>
  <div class="piece tri-gold-lg p148"></div>
  <div class="piece dot-yellow p149"></div>
  <div class="piece rect-lime p150"></div>

  <!-- Medium-slow + burst -->
  <div class="piece tri-gold-lg p151"></div>
  <div class="piece tri-blue-lg p152"></div>
  <div class="piece dot-purple p153"></div>
  <div class="piece rect-pink-xl p154"></div>
  <div class="piece tri-coral p155"></div>
  <div class="piece sq-orange p156"></div>
  <div class="piece rect-teal-lg p157"></div>
  <div class="piece dot-green p158"></div>
  <div class="piece rect-lime p159"></div>
  <div class="piece tri-gold p160"></div>

  <!-- More — p161–p220 -->
  <div class="piece tri-blue-sm p161"></div>
  <div class="piece rect-pink-lg p162"></div>
  <div class="piece dot-yellow p163"></div>
  <div class="piece tri-gold-lg p164"></div>
  <div class="piece tri-blue-lg p165"></div>
  <div class="piece dot-purple p166"></div>
  <div class="piece tri-red p167"></div>
  <div class="piece rect-teal p168"></div>
  <div class="piece sq-orange p169"></div>
  <div class="piece rect-lime p170"></div>

  <div class="piece tri-coral p171"></div>
  <div class="piece dot-green p172"></div>
  <div class="piece rect-pink-xl p173"></div>
  <div class="piece tri-gold p174"></div>
  <div class="piece tri-blue-md p175"></div>
  <div class="piece dot-yellow p176"></div>
  <div class="piece rect-teal-lg p177"></div>
  <div class="piece tri-blue-xs p178"></div>
  <div class="piece sq-orange p179"></div>
  <div class="piece dot-purple p180"></div>

  <div class="piece tri-gold-lg p181"></div>
  <div class="piece rect-pink-sm p182"></div>
  <div class="piece rect-teal p183"></div>
  <div class="piece tri-coral p184"></div>
  <div class="piece dot-green p185"></div>
  <div class="piece tri-red p186"></div>
  <div class="piece rect-lime p187"></div>
  <div class="piece tri-blue-lg p188"></div>
  <div class="piece dot-yellow p189"></div>
  <div class="piece tri-gold p190"></div>

  <div class="piece rect-pink-lg p191"></div>
  <div class="piece dot-purple p192"></div>
  <div class="piece tri-blue-sm p193"></div>
  <div class="piece sq-orange p194"></div>
  <div class="piece tri-coral p195"></div>
  <div class="piece rect-teal-lg p196"></div>
  <div class="piece tri-gold-lg p197"></div>
  <div class="piece dot-green p198"></div>
  <div class="piece tri-blue-md p199"></div>
  <div class="piece rect-pink-xl p200"></div>

  <div class="piece dot-yellow p201"></div>
  <div class="piece tri-red p202"></div>
  <div class="piece tri-gold p203"></div>
  <div class="piece tri-blue-lg p204"></div>
  <div class="piece rect-lime p205"></div>
  <div class="piece dot-purple p206"></div>
  <div class="piece tri-coral p207"></div>
  <div class="piece sq-orange p208"></div>
  <div class="piece rect-teal p209"></div>
  <div class="piece tri-blue-xs p210"></div>

  <div class="piece rect-pink-sm p211"></div>
  <div class="piece dot-green p212"></div>
  <div class="piece tri-gold-lg p213"></div>
  <div class="piece rect-teal-lg p214"></div>
  <div class="piece tri-blue-md p215"></div>
  <div class="piece dot-yellow p216"></div>
  <div class="piece rect-pink-lg p217"></div>
  <div class="piece tri-red p218"></div>
  <div class="piece tri-coral p219"></div>
  <div class="piece tri-gold p220"></div>

</div>
